<template>
  <v-flex xs4 class="payment-method">
    <v-card :raised="!paymentMethod.default">
      <v-card-text>
        <div style="float:left">
          <v-icon large>fab fa-cc-{{paymentMethod.method.brand | lowercase}}</v-icon>
        </div>
        <div style="margin-left:55px;">
          {{paymentMethod.description}}<br>
          <span v-html="paymentMethod.address"></span>
        </div>
      </v-card-text>
      <v-card-actions>
          <v-icon v-if="paymentMethod.default">mdi-bookmark</v-icon>
          <v-spacer/>
          <v-btn flat icon small @click="$emit('delete', paymentMethod.id)"><v-icon>mdi-delete</v-icon></v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: {
    paymentMethod: Object
  },

  data () {
    return {
      defaultCard: 'fal fa-credit-card'
    }
  },

  methods: {
    getCardType (number) {
      // visa
      var re = new RegExp('^4')
      if (number.match(re) != null) return 'fab fa-cc-visa'

      // Mastercard
      if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number)) return 'fab fa-cc-mastercard'

      // AMEX
      re = new RegExp('^3[47]')
      if (number.match(re) != null) return 'fab fa-cc-amex'

      // Discover
      re = new RegExp('^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)')
      if (number.match(re) != null) return 'fab fa-cc-discover'

      // Diners
      re = new RegExp('^36')
      if (number.match(re) != null) return 'fab fa-cc-diners-club'

      // Diners - Carte Blanche
      re = new RegExp('^30[0-5]')
      if (number.match(re) != null) return 'fab fa-cc-diners-club'

      // JCB
      re = new RegExp('^35(2[89]|[3-8][0-9])')
      if (number.match(re) != null) return 'fab fa-cc-jcb'

      // Visa Electron
      re = new RegExp('^(4026|417500|4508|4844|491(3|7))')
      if (number.match(re) != null) return 'fab fa-cc-visa'

      return this.defaultCard
    }
  }
}
</script>



// WEBPACK FOOTER //
// payment-method.vue?1393c711